import { Box, Spinner } from '@amzn/awsui-components-core';
import React from 'react';

/**
 * Simple loading component displayed during authentication
 * Centered horizontally and vertically on the page
 */
const AuthLoader: React.FC = () => {
  return (
    <div
      data-testid="auth-loader"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
      }}
    >
      <Box textAlign="center" data-testid="spinner-container">
        <Spinner size="large" data-testid="spinner" />
        <Box fontSize="heading-m" padding={{ top: 'm' }}>
          Loading...
        </Box>
      </Box>
    </div>
  );
};

export default AuthLoader;
